// extracted by mini-css-extract-plugin
module.exports = {"head":"SetBlockHead_head__1C4je","editBtn":"SetBlockHead_editBtn__2OEvL","discardBtn":"SetBlockHead_discardBtn__3gVOv","confirmBtn":"SetBlockHead_confirmBtn__2AQKf"};